<template>

    <TemplateBasic 
      v-bind:breadcrumb="breadcrumb"
      v-bind:permission="permission">

      <div class="row form-group">

        <div class="col">
        </div>

        <AppSearch 
          v-show="false"
          ref="pageSearch"
          class="col-md-4"
          v-on:search-data-change="loadLostPasscardApplication" />
        
      </div>

      <AppFilter 
        ref="carparkFilter" 
        filterKey="carparkID"
        v-on:filter-data-change="onFilterCarparkChange" >
        <label>
          Car Park
        </label>
      </AppFilter>

      <AppFilter 
        ref="licenseFilter" 
        filterKey="licenseID"
        v-on:filter-data-change="onFilterLicenseChange" >
        <label>
          Parking License
        </label>
      </AppFilter>

      <AppFilter 
        ref="passcardFilter" 
        filterKey="passcardID"
        v-on:filter-data-change="onFilterPasscardChange" >
        <label>
          Passcard
        </label>
      </AppFilter>

      <AppTable 
        v-show="showLeaseData"
        ref="pageTable" 
        v-bind:tableParameter="LEASE_PARAM" 
        v-bind:permission="permission"
        v-on:table-data-click="onTableDataClick" 
        v-on:table-page-change="onTablePageChange" />

      <AppForm
        v-show="showLeaseData"
        ref="pageForm" 
        v-bind:formParameter="PAYMENT_PARAM"
        v-bind:permission="permission"
        v-on:form-input="onFormInput"/>

      <TemplateButton 
        v-show="showLeaseData"
        class="btn btn-rounded btn-info btn-block-xs-only"
        v-on:click="onProceedClick">
        {{ proceedButtonText }}
      </TemplateButton>

      <TemplateFeedback ref="pageFeedback" />

    </TemplateBasic>

</template>

<script>
import TemplateBasic from "@/components/Template/TemplateBasic";
import TemplateButton from "@/components/Template/TemplateButton";
import TemplateFeedback from "@/components/Template/TemplateFeedback";
import AppSearch from "@/components/App/AppSearch";
import AppPaging from "@/components/App/AppPaging";
import AppFilter from "@/components/App/AppFilter";
import AppTable from "@/components/App/AppTable";
import AppAddButton from "@/components/App/AppAddButton";
import AppForm from "@/components/App/AppForm";
import AppModalForm from "@/components/App/AppModalForm";
import validation from "@/components/Utility/Validation"
import helper from "@/components/Utility/Helper"

var querystring = require('querystring');

const LEASE_PARAM = [
  {
    key: 'application',
    text: 'LDF Form No.',
    table_custom: function(dataResult, dataIndex, dataParameter, parameterIndex) {
      let parameterItem = dataParameter[parameterIndex];
      let dataItem = dataResult[dataIndex];
      if(dataItem['jt-summary']) return;
      return `<a href="${helper.WEB_URL}/passcardLostDamageFaultyForm?carparkID=${dataItem.carparkID}&applicationID=${dataItem.applicationID}">${helper.plFormLDFNum(dataItem.applicationID, dataItem.carparkID)}</a>`;
    },
    form_hide: true, 
  },
  {
    key: 'parkingLicense',
    text: 'Parking License',
    table_custom: function(dataResult, dataIndex, dataParameter, parameterIndex) {
      let parameterItem = dataParameter[parameterIndex];
      let dataItem = dataResult[dataIndex];
      if(dataItem['jt-summary']) return;
      return `<a target="_blank" href="${helper.WEB_URL}/parkinglicenseView?licenseID=${dataItem['_licenseID']}">${helper.plFormPLNum(dataItem['_licenseNum'], dataItem['_carparkNum'])}</a>`;
    },
    form_hide: true, 
  },
  {
    key: '_customerAccount',
    text: 'Account Holder',
    table_custom: function(dataResult, dataIndex, dataParameter, parameterIndex) {
      let parameterItem = dataParameter[parameterIndex];
      let dataItem = dataResult[dataIndex]['_customer'];
      if(!dataItem.id) {
        return '';
      }
      if(dataItem.isCompany) {
        return `<a target="_blank" href="${helper.WEB_URL}/companyForm?customerID=${dataItem.id}">${dataItem.name}</a><br>${dataItem.nationalID}`;
      } else {
        return `<a target="_blank" href="${helper.WEB_URL}/personalForm?customerID=${dataItem.id}">${dataItem.name}</a><br>${dataItem.nationalID}`;
      }
    },
  },
  {
    key: '_carparkName',
    text: 'Car Park',
    table_custom: function(dataResult, dataIndex, dataParameter, parameterIndex) {
      let parameterItem = dataParameter[parameterIndex];
      let dataItem = dataResult[dataIndex];
      return `<a target="_blank" href="${helper.WEB_URL}/carparkForm?carparkID=${dataItem.carparkID}">${dataItem['_carparkName']}</a>`;
    },
  },
  {
    key: '_zoneName',
    text: 'Zone',
  },
  {
    key: '_productName',
    text: 'Product Name',
  },
  {
    key: '_parkerInformation',
    text: 'Parker Information',
  },
  {
    key: '_foundPasscardType',
    text: 'Found Passcard Type',
  },
  {
    key: '_foundPasscardSku',
    text: 'Found Passcard',
  },
  {
    key: 'status2',
    text: 'Status',
  },
  {
    key: '_returnPasscardType',
    text: 'Return New Passcard Type',
  },
  {
    key: '_returnPasscardSku',
    text: 'Return New Passcard',
  },
];
const LEASE_PARAM_MAP = helper.transformParamToMap(LEASE_PARAM);

const PAYMENT_PARAM = [
  {
    key: 'remark',
    text: 'Remark',
    form_textarea: true,
    form_input_validation: [],
  },
  {
    key: 'staffID',
    text: 'Staff Name',
    form_select: [],
  },
  {
    key: 'staffNo',
    text: 'Staff No',
    form_input_attr: { disabled: true },
  },
]
const PAYMENT_PARAM_MAP = helper.transformParamToMap(PAYMENT_PARAM);


export default {
  name: "PagePasscardLostDamageFaultyApplication",
  components: {
    TemplateBasic,
    TemplateButton,
    AppSearch,
    AppPaging,
    AppFilter,
    AppTable,
    AppAddButton,
    AppForm,
    AppModalForm,
    TemplateFeedback,
  },
  data () {
    return {
      permission : null,
      breadcrumb : [
        { name: 'Home', url: helper.WEB_URL },
        { name: 'Passcard' },
        { name: 'Lost and Found', url: '/passcardLostAndFound' },
        { name: 'Application' },
      ],

      LEASE_PARAM,
      LEASE_PARAM_MAP,

      PAYMENT_PARAM,
      PAYMENT_PARAM_MAP,

      pageStaff: null,
      pageCarpark: null,
      pageZone: null,
      pagePasstype: null,
      pagePasscard: null,
      pageCustomer: null,
      pageTermination: null,
      pageLease: null,
      pageSeason: null,
      pageFees: {},
      pageParker: null,

      proceedButtonText: 'Proceed',
      showLeaseData: false,
    }
  },
  mounted() {
    if(!helper.hasViewPermission(this.permission = helper.getPermission(this))) {
      return;
    }
    
    this.$refs['carparkFilter'].formatFilterOptionText = (dataItem) => dataItem.carparkCode ? `${dataItem.carparkCode} - ${dataItem.name}` : dataItem.name;
    this.$refs['licenseFilter'].formatFilterOptionText = option => {
      let text = helper.plFormPLNum(option.licenseOperatorNum, option.carparkID);
      let customer = option['_customer'];
      text += customer ? ` - ${customer.name} (${customer.nationalID})` : '';
      return text;
    };
    this.$refs['passcardFilter'].formatFilterOptionValue = dataItem => dataItem['_passcard'] ? dataItem['id'] : '';
    this.$refs['passcardFilter'].formatFilterOptionText = dataItem => `${helper.plFormLDFNum(dataItem['applicationID'], dataItem['carparkID'])} - ${dataItem['_passcard']['sku']}`;

    this.$refs['pageForm'].setForm(true, null, true);

    this.loadStaff();
  },
  methods: {
    loadStaff() {
      let feedbackItem = 'staff data';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);
      this.$http
        .get(
          helper.SERVER_URL + '/api2/personnel/',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.pageStaff = response.data;
          if(response.data && response.data.length > 0) {
            helper.inputSelectSetOption(this.PAYMENT_PARAM_MAP['staffID'], this.pageStaff = response.data);
            this.$refs['pageFeedback'].setFeedbackMessage();
            this.loadCarpark();
          } else {
            this.$refs['pageFeedback'].setFeedbackError('No ' + feedbackItem + ' available.');
          }
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        })
    },
    loadCarpark() {
      let feedbackItem = 'car park data';
      this.$refs['carparkFilter'].setFilterLoading('Loading ' + feedbackItem);

      this.$http
        .get(
          helper.SERVER_URL + '/api2/carpark/',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.pageCarpark = response.data;
          this.$refs['carparkFilter'].setFilterDataWithValueIfFirstLoad(response.data, this.$route.query.carparkID);

          this.loadZone();
        })
        .catch(error => {
          this.$refs['carparkFilter'].setFilterError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        });
    },
    loadZone() {
      let feedbackItem = 'zone data';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);

      this.$http
        .get(
          helper.SERVER_URL + '/api2/zone/',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFeedback'].setFeedbackMessage();
          this.pageZone = response.data;
          this.loadCustomer();
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        });
    },
    loadCustomer() {
      let feedbackItem = 'customer data';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);

      this.$http
        .get(
          helper.SERVER_URL + '/api2/customer/',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFeedback'].setFeedbackMessage();
          this.pageCustomer = response.data;
          this.loadPasscardType();
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        });
    },
    loadPasscardType() {
      let feedbackItem = 'passcard type data';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);

      this.$http
        .get(
          helper.SERVER_URL + '/api2/passtype/',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.pagePasstype = response.data;

          if(response.data && response.data.length > 0) {
            this.$refs['pageFeedback'].setFeedbackMessage();
            this.loadLicense();
          } else {
            this.$refs['pageFeedback'].setFeedbackError('No passcard available.');
          }
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        });
    },
    loadLicense() {
      let feedbackItem = 'license data';
      this.$refs['licenseFilter'].setFilterLoading('Loading ' + feedbackItem);

      this.$http
        .get(
          helper.SERVER_URL + '/api2/carpark/' + this.$refs['carparkFilter'].filterValue + '/license/',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.pageLicense = response.data;
          response.data.forEach(k => {
            k['_customer'] = this.pageCustomer.find(j => j.id === k.customerID);
            k['_carpark'] = this.pageCarpark.find(j => j.id === k.carparkID);
          });
          this.$refs['licenseFilter'].setFilterDataWithValueIfFirstLoad(response.data, this.$route.query.licenseID);

          if(response.data && response.data.length > 0) {
            this.loadPasscard();
          }
        })
        .catch(error => {
          this.$refs['licenseFilter'].setFilterError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        });
    },
    loadPasscard() {
      let feedbackItem = 'passcard data';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);

      this.$http
        .get(
          helper.SERVER_URL + '/api2/carpark/' + this.$refs['carparkFilter'].filterValue + '/passcard/',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFeedback'].setFeedbackMessage();
          this.pagePasscard = response.data;
          response.data.forEach(k => {
            let passtype = this.pagePasstype.find(j => j.id === k.passtypeID) || {};
            k['_passtype'] = passtype;
            k['option'] = passtype.name ? k['sku'] + ' - ' + passtype.name : k['sku'];
          });
          this.loadLostPasscardApplication();
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        });
    },
    loadLostPasscardApplication() {
      this.$refs['pageTable'].setTableData(this.pageLease = null);

      let feedbackItem = 'lease data';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);

      let url = helper.SERVER_URL + '/api2';
      // if(this.$refs['licenseFilter'].filterValue) {
      //   url += '/license/' + this.$refs['licenseFilter'].filterValue;
      // }
      url += '/request/?type1=passcardLostDamageFaulty&type2=Lost';
      url = helper.appendSearchQuery(url, this.$refs['pageSearch'].searchValue);
      
      this.$http
        .get(
          url,
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFeedback'].setFeedbackMessage('');
          this.pageLease = response.data.filter(k => {
            if(!helper.compareID(k['licenseID'], this.$refs['licenseFilter'].filterValue)) {
              return false;
            }
            if(k['status4'] === 'Found') {
              return false;
            }
            return true;
          });
          if(this.pageLease.length === 0) {
            this.$refs['pageFeedback'].setFeedbackError('This parking license do not have any lost passcard application form.');
            return;
          }

          this.loadLeaseData();
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        })
    },
    loadLeaseData() {
      if(!this.pageSeason) {
        this.loadSeason();
        return;
      }

      if(!this.pageParker) {
        this.loadParker();
        return;
      }

      if(this.checkSeasonFees()) {
        return;
      }

      this.pageLease.forEach(k => {
        k['_license'] = this.pageLicense.find(k => helper.compareID(k.id, this.$refs['licenseFilter'].filterValue)) || {};
        k['_licenseID'] = k['_license']['id'];
        k['_licenseNum'] = k['_license']['licenseOperatorNum'];
        k['_carparkNum'] = k['_license']['carparkID'];

        k['_customer'] = this.pageCustomer.find(j => j.id === k['_license']['customerID']) || {};
        k['_carpark'] = this.pageCarpark.find(j => j.id === k['_license']['carparkID']) || {};
        k['_carparkName'] = (k['_carpark'] || {}).name;

        k['_product'] = this.pageSeason.find(j => j.id === k['seasonID']) || {};
        k['_productName'] = (k['_product'] || {}).name;
        k['_parker'] = this.pageParker.find(j => j.id === k['parkerID']) || {};
        k['_parkerInformation'] = helper.plFormParker(k['_parker']);

        k['_zone'] = this.pageZone.find(j => j.id === (k['_product'] || {})['zoneID']);
        k['_zoneName'] = (k['_zone'] || {}).name;

        if(k['passcardID']) {
          k['_passcard'] = this.pagePasscard.find(j => helper.compareID(j.id, k['passcardID'])) || {};
          k['foundPasscardID'] = k['_passcard'].id;
          k['_foundPasscardSku'] = k['_passcard'].sku;
          k['_foundPasscardType'] = k['_passcard']['_passtype'].name;
        }
      });

      this.$refs['passcardFilter'].setFilterData(this.pageLease);
      // this.$refs['pageTable'].setTableData(this.pageLease);
    },
    loadSeason() {
      let feedbackItem = 'product data';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);
      this.$http
        .get(
          helper.SERVER_URL + '/api2/carpark/' + this.$refs['carparkFilter'].filterValue + '/season/',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          if(response.data && response.data.length > 0) {
            this.pageSeason = response.data;
            this.$refs['pageFeedback'].setFeedbackMessage();
            this.loadLeaseData();
          } else {
            this.$refs['pageFeedback'].setFeedbackError('No product data available.');
          }
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        })
    },
    loadSeasonFees(seasonID) {
      this.pageFees[seasonID] = null;

      let feedbackItem = 'product fees data';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);

      this.$http
        .get(
          // helper.SERVER_URL + '/api2/season/' + seasonID + '/currentSeasonFees/',
          helper.SERVER_URL + '/api2/season/' + seasonID + '/seasonFees/',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          // if(response.data && response.data.length > 0) {
          if(this.pageFees[seasonID] = response.data.find(k => k.isActive)) {
            if(this.pageFees[seasonID] = response.data[0]) {
              this.$refs['pageFeedback'].setFeedbackMessage();
              this.loadLeaseData();
            } else {
              this.$refs['pageFeedback'].setFeedbackError('No active ' + feedbackItem + ' available.');
            }
          } else {
            this.$refs['pageFeedback'].setFeedbackError('No ' + feedbackItem + ' available.');
          }
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        })
    },
    loadParker() {
      let license = this.pageLicense.find(k => helper.compareID(k.id, this.$refs['licenseFilter'].filterValue));

      let feedbackItem = 'parker data';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);
      this.$http
        .get(
          helper.SERVER_URL + '/api2/customer/' + license['_customer']['id'] + '/parker/',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          if(response.data && response.data.length > 0) {
            this.pageParker = response.data;
            this.$refs['pageFeedback'].setFeedbackMessage();
            this.loadLeaseData();
          } else {
            this.$refs['pageFeedback'].setFeedbackError('No parker available.');
          }
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        })
    },
    checkSeasonFees() {
      for(let leaseData of this.pageLease) {
        if(leaseData['seasonID'] && this.pageFees[leaseData['seasonID']] === undefined) {
          this.loadSeasonFees(leaseData['seasonID']);
          return true;
        }
      };
    },

    onFilterCarparkChange() {
      this.showLeaseData = false;
      this.$refs['pageTable'].setTableData(this.pageLease = null);
      this.$refs['licenseFilter'].setFilterData(null);
      this.$refs['passcardFilter'].setFilterData(null);
      this.loadLicense();
    },
    onFilterLicenseChange() {
      this.showLeaseData = false;
      this.$refs['pageTable'].setTableData(this.pageLease = null);
      this.$refs['passcardFilter'].setFilterData(null);
      this.pageSeason = null;
      this.pageParker = null;
      this.loadLostPasscardApplication();
    },
    async onFilterPasscardChange() {
      let temp = [];
      let total = 0;
      this.pageLease.forEach(k => {
        if(helper.compareID(k['id'], this.$refs['passcardFilter'].filterValue)) {
          temp.push(k);
          total += 1;//k
        }
      });

      if(temp.length === 0) {
        this.$refs['pageFeedback'].setFeedbackError('Please select passcard before proceed');
        return;
      }

      let lease = this.pageLease.filter(k => helper.compareID(k.id ,this.$refs['passcardFilter'].filterValue));

      this.showLeaseData = false;

      if(helper.parseDateTime(lease[0]['createDate']).add(14, 'd').unix() < moment().startOf('day').unix()) {
        this.$refs['pageFeedback'].setFeedbackError('Lost and found passcard application only can apply within 14 days after lost passcard application form submitted.');
        return;
      }

      let feedbackItem = 'lease data';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);
      this.$http
        .get(
          helper.SERVER_URL + '/api2/lease/' + lease[0]['leaseID'],
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFeedback'].setFeedbackMessage();
          lease[0]['returnPasscardID'] = response.data[0]['passcardID'];
          if(lease[0]['returnPasscardID']) {
            lease[0]['returnPasscard'] = this.pagePasscard.find(j => helper.compareID(j.id, lease[0]['returnPasscardID'])) || {};
            lease[0]['_returnPasscardSku'] = lease[0]['returnPasscard'].sku;
            lease[0]['_returnPasscardType'] = lease[0]['returnPasscard']['_passtype'].name;
          } else {
            lease[0]['_returnPasscardSku'] = 'N/A';
            lease[0]['_returnPasscardType'] = 'N/A';
          }
          this.$refs['pageTable'].setTableData(lease);
          this.showLeaseData = true;
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        });
    },

    onTableDataClick(tableData, tableDataIndex) {
      this.$refs['pageFeedback'].setFeedbackMessage();
      this.$refs['pageModal'].setModalOpen(false, 'Issue Passcard', tableData[tableDataIndex]);
    },
    onFormInput(formData, formParameter, input) {
      if(formParameter.key === 'staffID') {
        let staff = helper.inputSelectFindOption(this.PAYMENT_PARAM_MAP['staffID'], formData['staffID']) || {}
        formData['staffNo'] = staff['personnelCode'];
      }
    },

    onProceedClick() {
      if(!this.$refs['pageForm'].validateForm()) {
        this.addApplication();
      }
    },

    addApplication() {
      let formData = this.$refs['pageForm'].formData;

      let temp = {};
      temp['carparkID'] = this.pageLicense.find(k => helper.compareID(k.id, this.$refs['licenseFilter'].filterValue))['carparkID'];
      temp['remark'] = formData['remark'];
      temp['staffID'] = formData['staffID'];
      temp['leases'] = [].concat(this.pageLease.find(k => helper.compareID(k.id, this.$refs['passcardFilter'].filterValue)));
      temp['operatorID'] = this.pageCarpark.find(k => helper.compareID(k.id, temp['carparkID'])).operatorID;
      temp['leases'] = JSON.stringify(temp['leases']);
      
      let feedbackItem = 'passcard lost and found appplication';
      this.$refs['pageFeedback'].setFeedbackLoading('Adding ' + feedbackItem);
      this.$http
        .post(
          helper.API_URL + '/api2/licensePasscardLostAndFound/create',
          querystring.stringify(temp),
          helper.createAxiosFormConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          // this.approveApplication(response.data);
          helper.redirect({ path: helper.WEB_URL + '/passcardLostAndFound', query: { carparkID: this.$refs['carparkFilter'].filterValue, licenseID: this.$refs['licenseFilter'].filterValue }});
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'adding', feedbackItem));
        })
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Page/Passcard/PagePasscardLostAndFoundApplication.vue